module.exports = __webpack_public_path__ + "img/visa.a5c74eaf.svg";